"use client";
import React from 'react';
import { Link } from 'react-router-dom';
import "../App.css";
import {
  FaIndustry,
  FaGraduationCap,
  FaBuilding,
  FaStore,
  FaUtensils,
  FaHotel,
  FaHome,
  FaBook,
  FaFlask,
  FaCapsules,
  FaHospital,
  FaShoppingCart,
  FaAward,
  FaCertificate,
  FaShieldAlt,
  FaCheckCircle
} from "react-icons/fa";

export default function ClientsPage() {
  return (
    <div className="page-wrapper light-section min-vh-100">
      {/* Hero Banner Section */}
      <div className="page-banner position-relative">
        <div className="glowing-orb primary top-50 start-50 translate-middle" style={{ width: '400px', height: '400px', opacity: 0.5 }}></div>
        <div className="container position-relative z-1 text-center">
          <h1 className="page-banner-title text-white">Our Clients</h1>
          <div className="page-banner-breadcrumb text-light opacity-75">
            <Link to="/" className="text-light text-decoration-none">Home</Link> <span>/</span> Our Clients
          </div>
        </div>
      </div>

      <section className="section-padding light-section">
        <div className="container text-center position-relative z-1">
          <span className="section-pill mb-3">Industries</span>
          <h2 className="section-heading text-dark mb-4 mb-md-5 fs-3 fs-md-2">Who We <span className="text-primary fst-italic">Serve</span></h2>

          <div className="row g-3 g-md-4 justify-content-center">
            {[
              { icon: <FaIndustry />, title: "Manufacture Company" },
              { icon: <FaGraduationCap />, title: "School" },
              { icon: <FaBuilding />, title: "Offices" },
              { icon: <FaStore />, title: "Stores" },
              { icon: <FaUtensils />, title: "Sugar Company" },
              { icon: <FaHotel />, title: "Hotels" },
              { icon: <FaHome />, title: "Home" },
              { icon: <FaBook />, title: "Library" },
              { icon: <FaFlask />, title: "Chemicals Company" },
              { icon: <FaCapsules />, title: "Pharmaceutical Company" },
              { icon: <FaHospital />, title: "Hospitals" },
              { icon: <FaShoppingCart />, title: "Super Market" },
            ].map((item, i) => (
              <div key={i} className="col-lg-3 col-md-4 col-6">
                <div className="feature-card white-card p-3 p-md-4 rounded-4 border-0 h-100 text-center transition-all hover-lift">
                  <div className="text-primary fs-2 fs-md-1 mb-2 mb-md-3">
                    {item.icon}
                  </div>
                  <h6 className="font-serif fw-bold text-dark mt-2 mt-md-3 mb-0 fs-6 fs-md-5">{item.title}</h6>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Certified Partners Section */}
      <section className="section-padding dark-section text-center" style={{ borderTop: '1px solid rgba(255,255,255,0.05)' }}>
        <div className="glowing-orb primary bottom-0 end-0" style={{ width: '300px', height: '300px' }}></div>
        <div className="container position-relative z-1">
          <span className="section-pill mb-3">Quality Standards</span>
          <h2 className="section-heading text-white mb-3 mb-md-4 fs-3 fs-md-2">Our Certified <span className="text-primary fst-italic">Partners & Standards</span></h2>
          <p className="text-light opacity-75 mx-auto mt-2 mt-md-3 mb-4 mb-md-5 px-2 px-md-0" style={{ maxWidth: '700px', lineHeight: '1.8' }}>
            Shree Kamdhenu Furniture is committed to high-grade industrial standards, certified raw materials, and verified quality credentials.
          </p>

          <div className="row g-3 g-md-4 justify-content-center">
            {[
              { icon: <FaAward />, title: "ISO 9001:2015 Certified", desc: "Quality management certified company manufacturing high-grade furniture." },
              { icon: <FaCertificate />, title: "TATA & Jindal Steel Partner", desc: "Sourcing premium ISI certified sheet metal and heavy raw materials." },
              { icon: <FaShieldAlt />, title: "Vocal for Local", desc: "Proudly supporting Indian manufacturing with 100% indigenous fabrication." },
              { icon: <FaCheckCircle />, title: "IndiaMart Verified Vendor", desc: "Trusted wholesale manufacturer and supplier with verified business credentials." }
            ].map((partner, idx) => (
              <div key={idx} className="col-12 col-sm-6 col-lg-3">
                <div className="glass-card p-3 p-md-4 rounded-4 h-100 text-center transition-all hover-lift">
                  <div className="text-primary fs-2 fs-md-1 mb-2 mb-md-3">{partner.icon}</div>
                  <h5 className="font-serif fw-bold text-white fs-6 mb-2">{partner.title}</h5>
                  <p className="text-light opacity-75 small mb-0" style={{ lineHeight: '1.6' }}>{partner.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

